<template>
    <div class="h-[calc(186px*3+40px)]">
        <div v-if="!isLoading"
            class="
                grid gap-4 
                grid-cols-1 
                sm:grid-cols-2
                md:grid-cols-3
                lg:grid-cols-4
                xl:grid-cols-5"
        >
            <div class="
                w-[226px] h-[186px] 
                rounded-md 
                flex flex-col justify-center items-center bg-white
                shadow-md
                cursor-pointer
                create-workflow-btn"
                v-on:click="this.createUserWorkflow"
            >
                <div class="flex flex-col justify-center items-center">
                    <svg class="plus-svg" width="50px" height="50px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                    </svg>
                    <h6 class="mt-3 font-bold text-color-blue">Новое подключение</h6>
                </div>
            </div>
            <div
                v-for="workflow in this.workflows" v-bind:key="workflow"
                class="
                    max-w-[226px] h-[186px] 
                    rounded-md border-2 border-transparent hover:border-blue-500
                    bg-white shadow-md
                    flex flex-col
                    relative
                    cursor-pointer 
                "
                v-on:click.self="redirectToWorkflow(workflow.id)"
                :class="{
                    'border-blue-500': workflow.isChecked
                }"
            >
                <div class="w-5/6 h-2/5 mx-auto my-3 rounded-t-md relative"
                    v-bind:class="getColorClass(workflow)"
                    v-on:click.self="redirectToWorkflow(workflow.id)"
                >
                    <!-- <CheckBox v-model="workflow.isChecked"/> -->
                    <WorkflowNameIcon 
                        :letters="this.getFirstLetters(workflow.name)" :width="40" :height="40"
                        class="absolute -bottom-5 left-2"
                        v-on:click="redirectToWorkflow(workflow.id)"
                    />
                </div>
                <div
                    class="flex justify-center items-center
                        py-3 select-none
                        font-bold text-base border-b border-gray-300"
                    v-on:click="redirectToWorkflow(workflow.id)"
                >
                    {{ workflow.name }}
                </div>
                <!-- Кнопки workflow -->
                <div class="absolute flex bottom-2 z-10 w-full">
                    <div class="flex items-center justify-between mx-2 w-full">
                        <!-- Добавить workflow в избранное -->
                        <div v-on:click="addToFavorite(workflow)" title="Добавить в избранное" class="ml-4 w-6 h-6 flex justify-center items-center rounded-md hover:bg-gray-200">
                            <svg v-if="workflow.is_favorite" viewBox="0 0 24 24" class="size-5 fill-yellow-400"><path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"></path></svg>
                            <svg v-else viewBox="0 0 24 24" class="size-5"><path d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z" style="fill: currentcolor;"></path></svg>
                        </div>
                        <ToolTip text="Удалить" position="bottom">
                            <div v-on:click="deleteWorkFlow(workflow)" class="w-6 h-6 mr-5 flex justify-center items-center rounded-md hover:bg-gray-200">
                                <TrashCanSvg class="size-6" />
                            </div>
                        </ToolTip>

                    </div>
                </div>
            </div>
        </div>
        <!-- Спиннер подгрузки -->
        <svg v-else class="animate-spin h-8 w-8 mt-32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="blue" stroke-width="3"></circle>
            <path class="opacity-100" fill="#0A84FF" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <div 
            class="
                h-10 w-40 mx-auto
                bg-blue-600 text-white text-sm 
                flex items-center justify-center 
                select-none cursor-pointer mt-10 
                hover:bg-blue-700 rounded-md"
            v-if="!this.isLoading && this.nextPage != null"
            v-on:click="loadMore()"
        >
            <div v-if="!this.isWorkflowsLoading">
                Загрузить ещё
            </div>
            <div v-else>
                <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </div>
        </div>

    </div>
</template>

<script>
// import CheckBox from '@/components/UI/CheckBox.vue';
import WorkflowNameIcon from '@/components/UI/WorkflowNameIcon.vue';
import { Api } from '@/service/api'
import { colors } from '@/service/config'
import TrashCanSvg from "@/components/UI/svg/TrashCanSvg.vue";
import ToolTip from "@/components/UI/ToolTip.vue";
export default {
    name: "WorkspaceItems",
    data() {
        return {
            workflows: [],
            selectedWorkflows: [],
            showTriggerSettings: false,
            isLoading: true,
            nextPage: 0,
            isWorkflowsLoading: false
        }
    },
    mounted: async function() {
        this.isLoading = true
        let api_data = await Api.getWorkflows()
        this.workflows = api_data.workflows
        this.nextPage = api_data.next_page
        this.sort_workflows()
        this.isLoading = false
    },
    components: {
        ToolTip,
        TrashCanSvg,
        // CheckBox,
        WorkflowNameIcon
    },
    methods: {
        getFirstLetters: function(name) {
            let strs = name.split(" ")
            if (strs.length < 2) {
                return strs[0][0]
            }
            else {
                return strs[0][0] + strs[1][0]
            }
        },
        deleteWorkFlow: async function(workflow) {
            this.$emit('deleteWorkflow', workflow)
        },
        redirectToWorkflow: function(workflow_id) {
            this.$router.push({"name": "FlowView", params: {workflow_id: workflow_id}})
        },
        createUserWorkflow: async function() {
            let newWorkflowId = await Api.createEmptyWorkflow()
            this.$router.push({"name": "CreateConnection", params:{workflow_id: newWorkflowId}})
        },
        addToFavorite: function(workflow) {
            if (workflow.is_favorite) {
                Api.removeFromFavorite(workflow.id)
            }
            else {
                Api.addToFavorite(workflow.id)
            }
            workflow.is_favorite = !workflow.is_favorite
            this.sort_workflows()
        },
        getColorClass: function(workflow) {
            return colors[workflow.color].class
        },
        sort_workflows: function() {
            this.workflows.sort((a, b) => {
                // Сначала сортируем по is_favorite (избранные сначала)
                if (a.is_favorite && !b.is_favorite) {
                    return -1;
                }
                if (!a.is_favorite && b.is_favorite) {
                    return 1;
                }

                // Если оба избранные или оба не избранные, сортируем по имени
                // Натуральная сортировка с учетом регистра
                return a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
            });
        },
        openTriggerSettingsModal: function() {
            this.showTriggerSettings = true
        },
        loadMore: async function() {
            if (this.isWorkflowsLoading) {
                return
            }
            this.isWorkflowsLoading = true
            let apiData = await Api.getWorkflows(this.nextPage)
            this.workflows.push(...apiData.workflows)
            this.nextPage = apiData.next_page
            this.isWorkflowsLoading = false
        }
    }

}
</script>

<style scoped>
    .checkbox {
        appearance: none;
        background-color: #dee8f5;;
        margin: 0;
        width: 15px;
        height: 15px;
        border-radius: 3px;
        display: grid;
        place-content: center;
        user-select: none;
    }
    .checkbox::before {
        content: "";
        width: 7px;
        height: 7px;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #0A84FF;
    }
    .checkbox:checked::before {
        transform: scale(1);
    }
    .checkbox:checked {
        border-color: #0A84FF;
    }
    .hover-hidden-show {
        display: flex;
    }
    .hover-show {
        display: none;
    }
    .hover-show:hover {
        cursor: pointer
    }
    .hover-hidden-show:hover {
        display: none;
    }
    .hover-hidden-show:hover ~ .hover-show {
        display: flex;
    }
    .plus-svg {
        fill: #0A84FF;
    }
    .text-color-blue {
        color: #0A84FF;
    }
    .create-workflow-btn:hover .plus-svg {
        fill: #fff;
    }
    .create-workflow-btn:hover .text-color-blue {
        color: #fff;
    }
    .create-workflow-btn:hover {
        background-color: #0A84FF;
    }
</style>